import React, { Component } from 'react'
import i18n from 'i18next'
import AnimateHeight from 'react-animate-height'

import Typography from '../../UniformComponents/Typography'
import './nps-answer-options.scss'

export default class NPSAnswerOptions extends Component {
    constructor(props) {
        super(props)
        this.state = { open: false }
    }

    toggle = () => {
        this.setState((prevState) => ({ open: !prevState.open }))
    }

    onKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault()
            this.toggle()
        }
    }

    renderScale = () => (
        <div className="nps-scale-container">
            <div className="nps-top-content">
                <span className="nps-fixed-scale">{i18n.t('questionBuilder.nps.fixed')}</span>

                <div className="nps-translated">
                    <i className="fal fa-globe" />

                    <span className="nps-fixed-scale">{i18n.t('questionBuilder.nps.translated')}</span>
                </div>
            </div>

            <div className="nps-scale-labels">
                <span>{i18n.t('questionBuilder.nps.scale.min')}</span>

                <span>{i18n.t('questionBuilder.nps.scale.max')}</span>
            </div>

            <div className="nps-scale">
                <div className="nps-bands">
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((score) => (
                        <div key={score} className="nps-score">{score}</div>
                    ))}
                </div>
            </div>
        </div>
    )

    render() {
        const { open } = this.state
        return (
            <div className="nps-answer-options">
                <div className="nps-header">
                    <div className="nps-title">
                        <i className="fas fa-lock" />
                        <Typography type="h4">{i18n.t('questionBuilder.nps.locked.title')}</Typography>
                    </div>
                    <div
                        role="button"
                        tabIndex={0}
                        className="nps-cta"
                        aria-expanded={open}
                        onClick={this.toggle}
                        onKeyDown={this.onKeyDown}
                    >
                        <span>
                            {i18n.t(open
                                ? 'questionBuilder.nps.locked.cta.hide'
                                : 'questionBuilder.nps.locked.cta.show')}
                        </span>
                        <i className={`fas ${open ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                    </div>
                </div>

                <AnimateHeight duration={250} height={open ? 'auto' : 0}>
                    <div className="nps-details">
                        <div style={{ display: 'flex', gap: 10 }}>
                            <i className="fas fa-lock" style={{ color: '#715AF8', paddingTop: 10 }} />

                            <div>
                                <Typography type="h4">{i18n.t('questionBuilder.nps.locked.heading')}</Typography>

                                <p>{i18n.t('questionBuilder.nps.locked.body1')}</p>

                                <p>{i18n.t('questionBuilder.nps.locked.body2')}</p>

                                <p style={{ color: '#8B99A7' }}>{i18n.t('questionBuilder.nps.locked.body3')}</p>
                            </div>
                        </div>
                    </div>
                </AnimateHeight>

                <div style={{ padding: 16 }}>
                    {this.renderScale()}
                </div>
            </div>
        )
    }
}
